<template lang="pug">
  div#app
        div#pageready(v-if="pageReady")
            div#header
                comp-header
            div#content
                div#left.column
                    comp-screen-share
                    comp-live-setting
                div#center
                    comp-live-stream
                div#right.column
                    comp-participants
                    comp-chat
            room-device-dialog(ref="roomDeviceDialog" @nextStep="showBeautyPresettingDialog")
            room-beauty-dialog(ref="roomBeautyDialog")
        div.pageNoReady(v-if="!pageReady && '' != wxAppid")
            div.qrcode
                wxlogin(
                    :appid="wxAppid"
                    :scope="'snsapi_login'"
                    :theme="'black'"
                    :redirect_uri="encodeURIComponent(redirectUri)"
                    rel="external nofollow"
                    )
        el-dialog.dialog-style-title(
            v-if="!getUtoken()"
            title="登录"
            :visible.sync="showLoginDialog"
            width="460px"
            :close-on-click-modal="false"
            :show-close="false"
        )
            div.login-form-div
                el-form(
                    ref="loginRef"
                    :model="loginFormMoel"
                    label-width="80px"
                    :rules="formRules"
                )
                    el-form-item(
                        label="id"
                        prop="id"
                    )
                        el-input.ddd(
                            v-model.number="loginFormMoel.id"
                            autocomplete="off"
                            placeholder="请输入id"
                        )
                    el-form-item(
                        style="text-align: right;"
                    )
                        el-button(
                            type="primary"
                            @click="loginHandle()"
                            :loading="loginLoading"
                        ) 登录
        div.pageNoReady(v-if="!pageReady && '' == wxAppid && '' != getUtoken()")
            el-button(type="primary" @click="logout") 退出登录
</template>

<script>
// import LibGenerateTestUserSig from '@/utils/lib-generate-test-usersig.min.js';
import {
    SET_APP_INFO,
    SET_ROOM_ID,
    UPDATE_ROOM_NAME,
    UPDATE_USER_INFO,
} from 'constants/mutation-types';
import compHeader from '@/components/comp-header';
import compScreenShare from '@/components/comp-screen-share';
import compLiveSetting from '@/components/comp-live-setting/index.vue';
import compLiveStream from '@/components/comp-live-stream';
import compParticipants from '@/components/comp-participants';
import compChat from '@/components/comp-chat';
import roomDeviceDialog from '@/components/comp-pre-setting/room-device-dialog.vue';
import roomBeautyDialog from '@/components/comp-pre-setting/room-beauty-dialog.vue';
import axios from 'axios';
import { mapState } from 'vuex';
import wxlogin from 'vue-wxlogin';
import { getUrlParam } from '@/utils/utils';
export default {
    name: 'App',
    components: {
        compHeader,
        compScreenShare,
        compLiveSetting,
        compLiveStream,
        compParticipants,
        compChat,
        roomBeautyDialog,
        roomDeviceDialog,
        wxlogin,
    },
    data() {
        return {
            redirectUri: "https://web.bjfkzc.com", // 正式
            // redirectUri: 'http://127.0.0.1', // 测试
            pageReady: false,
            timeObj: null,
            wxAppid: '', // wx98c4ef52f2af53e5
            sdkAppId: 0,
            expireTime: 604800,
            userSig: '',
            shareUserSig: '',
            anchorUserInfo: {
                // 用户ID
                userId: '',
                // 用户昵称
                userName: '主播',
                // 用户头像
                userAvatar: '',
            },
            roomInfo: {
                // 房间id
                roomId: 0,
                // 房间昵称
                roomName: '我的直播间',
            },
            showLoginDialog: false,
            loginFormMoel: {
                id: '',
            },
            loginLoading: false,
            formRules: {
                id: [
                    { required: true, message: '请输入id', trigger: 'blue' },
                    { type: 'number', message: 'id必须是数字', trigger: 'blue' }
                ]
            }
        };
    },
    computed: {
        ...mapState({
            // 房间人数
            memberCount: 'memberCount',
            // 控制人数
            controlMemberCount: 'controlMemberCount',
            // 点赞数
            likeNum: 'likeNum',
            // 消息数
            messageCount: 'messageCount',
            roomId: 'roomId',
        }),
    },
    methods: {
        async loginHandle() {
            this.loginLoading = true;
            const that = this;
            this.$refs['loginRef'].validate((valid) => {
                if (valid) {
                    console.log('valid', valid);
                    this.submitValid();
                } else {
                    that.loginLoading = false;
                    return false;
                    // console.log('error sbmit');
                }
            });
        },
        async submitValid() {
            const param = {
                id: this.loginFormMoel.id
            };
            const getSig = await axios.post(`${process.env.VUE_APP_BASE_URL}` + 'member/auth/jjfkdiwopssjkgjjhwwpskmxnshnlqqqiasjf', param);
            if (getSig.status == 200) {
                if (getSig.data.code == 0 && getSig.data.data.accessToken) {
                    localStorage.setItem('utoken', getSig.data.data.accessToken);
                    this.init3();
                } else {
                    if (getSig.data.msg) {
                        this.$message.error(getSig.data.msg || '登陆错误，请联系管理员');
                    } else {
                        this.$message.error(getSig.data.data.msg || '登陆错误，请联系管理员');
                    }
                }
                this.loginLoading = false;
            } else {
                this.$message.error('登陆错误，请联系管理员');
                this.loginLoading = false;
            }
            console.log('getSig', getSig);
        },
        logout() {
            localStorage.removeItem('utoken');
            window.location.href = '/';
        },
        getUtoken() {
            return '' || localStorage.getItem('utoken');
        },
        // 显示设置预设置弹窗
        showDevicePresettingDialog() {
            this.$refs.roomDeviceDialog.handleShowDeviceDialog();
        },
        // 显示美颜预设置弹窗
        showBeautyPresettingDialog() {
            this.$refs.roomBeautyDialog.handleShowBeautyDialog();
        },
        // 设置TUIPusher配置信息
        handlePusherInfo() {
            if (this.sdkAppId === '' || this.secretKey === '') {
                alert(`${this.$t('basic.Please configure your SDKAPPID')}\r\n\r\nconfig/basic-info-config.js`);
            }
            // const generator = new LibGenerateTestUserSig(this.sdkAppId, this.secretKey, this.expireTime);
            // const userSig = generator.genTestUserSig(this.anchorUserInfo.userId);
            // const shareUserSig = generator.genTestUserSig(`share_${this.anchorUserInfo.userId}`);
            this.$store.commit(SET_APP_INFO, {
                sdkAppId: this.sdkAppId,
                userSig: this.userSig,
                shareUserSig: this.shareUserSig,
            });
            this.$store.commit(SET_ROOM_ID, this.roomInfo.roomId);
            this.$store.commit(UPDATE_ROOM_NAME, this.roomInfo.roomName);
            this.$store.commit(UPDATE_USER_INFO, {
                userId: `${this.anchorUserInfo.userId}cxb`,
                userName: this.anchorUserInfo.userName,
                userAvatar: this.anchorUserInfo.userAvatar,
            });
        },
        // 退出直播间
        async handleExit() {

            //手动关闭直播间

            let payload = {
                data: 4 + "",
                description: "",
                extension: "",
                cmd: 23
            }
            this.$eventBus.$emit('onSendCustomGroupMessage', payload);
            // 处理退出直播间
        },
        // 退出登录
        async handleLogout() {

            // 处理退出登录
            this.logout()
        },
        // 更新直播间信息
        async updateLiveInfoHandle() {
            console.log('更新直播间信息')
            const that = this;
            console.log('roomId', {
                id: that.roomId,
                viewers: that.memberCount, // 观看人数 初始主播 从im 服务返回 同步给初始进入的普通用户
                conViewers: that.controlMemberCount, // 控制人数 kzrscount
                messageCount: that.messageCount, // 消息数 msgcount
                likeCount: that.likeNum, // 点赞数 likecount
            });
            that.timeObj = setTimeout(async () => {
                // { url: 'app/live/updateLiveInfo', data }
                axios.post(`${process.env.VUE_APP_BASE_URL}` + 'app/live/updateLiveInfo', {
                    id: that.roomId,
                    viewers: that.memberCount, // 观看人数 初始主播 从im 服务返回 同步给初始进入的普通用户
                    conViewers: that.controlMemberCount, // 控制人数 kzrscount
                    messageCount: that.messageCount, // 消息数 msgcount
                    likeCount: that.likeNum, // 点赞数 likecount
                });
                that.updateLiveInfoHandle();
            }, 8000);
        },
        async showDevicePresettingDialogHandle() {
            this.showDevicePresettingDialog();
        },
        async init1() {
            // console.log('fdf', process.env.NODE_ENV);
            // console.log('VUE_BASE_URL', process.env.VUE_APP_BASE_URL);
            // console.log('VUE_BASE_URL', process.env);
            // const that = this;
            const result1 = await axios.get(`${process.env.VUE_APP_BASE_URL}` + 'member/user/getOpenWechatAppid', {});
            if (result1.status != 200 || null == result1.data.data || '' == result1.data.data) {
                this.$message.error(result1.data.msg || 'oauth2 授权错误');
            } else {
                this.wxAppid = result1.data.data;
            }
            console.log('getOpenWechatAppid', result1);
        },
        async init2(code) {
            const result1 = await axios.post(`${process.env.VUE_APP_BASE_URL}` + 'member/user/codeexchangeaccesstoken', {
                code,
            });
            console.log('codeexchangeaccesstoken', result1);
            if (result1.status != 200 || null == result1.data.data.accessToken || '' == result1.data.data.accessToken) {
                this.$message.error('获取accessToken错误');
            } else {
                localStorage.setItem('utoken', result1.data.data.accessToken);
                window.location.href = '/';
            }
        },
        getReqHeader() {
            return {
                headers: { Authorization: `Bearer ${localStorage.getItem('utoken')}` },
            };
        },
        getUserInfo() {
            return axios.get(`${process.env.VUE_APP_BASE_URL}` + 'member/user/get', this.getReqHeader());
            // if (result.status != 200 && !result.data.data.id) {
            //     this.$message({
            //         message: '获取用户信息错误',
            //         type: 'oauth2 错误',
            //     });
            //     return false;
            // }
            // this.anchorUserInfo.userId = result.data.data.id
            // this.anchorUserInfo.userName = result.data.data.nickname || '主播'
            // this.anchorUserInfo.userAvatar = result.data.data.avatar || ''
        },
        getLiveInfo() {
            return axios.get(`${process.env.VUE_APP_BASE_URL}` + 'app/live/getStartLiveInfo', this.getReqHeader());
            // if (result.status != 200 && !result.data.data.id) {
            //     this.$message({
            //         message: '获取直播间错误',
            //         type: 'oauth2 错误',
            //     });
            //     return false;
            // }
            // this.roomInfo.roomId = result.data.data.id
            // this.roomInfo.roomName = result.data.data.fullName
        },
        msgBox(title, msg, cb) {
            console.log('p111111', cb)
            // const that = this;
            this.$alert(msg, title, {
                confirmButtonText: '确定',
                callback: (action) => {
                    cb(action);
                    // console.log('action', action);
                },
            });
        },
        async init3() {
            console.log('获取用户信息 && 获取直播键信息后 初始化页面');
            const getSig = await axios.post(`${process.env.VUE_APP_BASE_URL}` + 'app/live/getSigShareSig', null, this.getReqHeader());
            if (getSig.status == 200 && null != getSig.data.data.sdkAppId) {
                this.sdkAppId = getSig.data.data.sdkAppId;
                this.userSig = getSig.data.data.userSig;
                this.shareUserSig = getSig.data.data.shareUserSig;
                const that = this;
                axios.all([that.getUserInfo(), that.getLiveInfo()])
                    .then(axios.spread((resultUserInfo, resultLiveInfo) => {
                        let isAllowed = true;
                        if (null == resultUserInfo.data.data.id) {
                            that.$message.error('获取用户信息错误');
                            isAllowed = false;
                        } else {
                            that.anchorUserInfo.userId = resultUserInfo.data.data.id;
                            that.anchorUserInfo.userName = resultUserInfo.data.data.nickname || '主播';
                            that.anchorUserInfo.userAvatar = resultUserInfo.data.data.avatar || '';
                        }
                        if (null == resultLiveInfo.data.data) {
                            that.msgBox('暂无直播', '暂无直播请检查是否创建直播间', () => {
                                that.logout()
                            });
                            isAllowed = false;
                            // that.$message.error('暂无直播');
                        } else if (resultLiveInfo.data.data.liveType != 1) {
                            that.msgBox('直播间直播类型错误', '直播间直播类型为移动端直播');
                            isAllowed = false;
                        } else {
                            that.roomInfo.roomId = resultLiveInfo.data.data.id;
                            that.roomInfo.roomName = resultLiveInfo.data.data.fullName;
                        }
                        console.log('全部请求完成', [resultUserInfo, resultLiveInfo]);
                        if (isAllowed) {
                            that.handlePusherInfo();
                            that.$eventBus.$on('exit', this.handleExit);
                            that.$eventBus.$on('logout', this.handleLogout);
                            that.updateLiveInfoHandle();
                            that.pageReady = true;
                            console.log('wxAppid', that.wxAppid);
                        }
                    }));
                // this.getUserInfo();
                // this.getLiveInfo();
            } else {
                this.$message.error('sig error');
                return false;
            }

            console.log('getSig', getSig);
            // 获取用户信息 && 获取直播键信息后 初始化页面
            // this.handlePusherInfo();
            // this.$eventBus.$on('exit', this.handleExit);
            // this.$eventBus.$on('logout', this.handleLogout);
            // this.updateLiveInfoHandle();
        },
        wsReady() {

        },
    },
    async created() {

    },
    mounted() {
        const dev = process.env.NODE_ENV == 'development';
        const devData = {
            mobile: '13333333333',
            password: '123123',
            avatar: 'df',
        };
        console.log('_____pageReady', this.pageReady);
        console.log('this.getUtoken()', this.getUtoken());
        let that = this
        if (dev) {
            // const that = this;
            // axios.post(`${process.env.VUE_APP_BASE_URL}` + 'member/auth/jdm17dya34jdbd6zh3kf93jsc7vbz1jfjbmloaf2sfw1qssds23jkowcnzjerg3hja', devData).then((res) => {
            //     console.log(res);
            //     localStorage.setItem('utoken', res.data.data.accessToken);
            //     setTimeout(() => {
            //         that.init3();
            //     }, 1000);
            // })
            //     .catch((res) => {
            //         console.log(res);
            //     });
            console.log('===========>>>>', this.getUtoken())
            if (!this.getUtoken()) {
                this.showLoginDialog = true;
            } else {
                that.init3();
            }
        } else {
            const code = getUrlParam('code');
            if (null == localStorage.getItem('utoken') && null == code) {
                this.init1();
            } else if (null == localStorage.getItem('utoken') && null != code) {
                this.init2(code);
            } else if (null != localStorage.getItem('utoken')) {
                this.init3();
            } else {
                this.$message.error('登录错误');
            }
        }
        this.$eventBus.$on('wsReady', this.wsReady);
    },
    beforeDestroy() {
        console.log('关闭onUnmounted关闭onUnmounted关闭onUnmounted')
        if (this.timeObj) {
            console.log('清空定时器', this.timeObj);
            clearTimeout(this.timeObj);
        }
        this.$eventBus.$off('exit', this.handleExit);
        this.$eventBus.$off('logout', this.handleLogout);
        this.$eventBus.$off('wsReady', this.wsReady);
    },
};
</script>

<style lang="stylus">
@import '~assets/style/black-element-ui.styl';
#app
  font-family Avenir, Helvetica, Arial, sans-serif
  --webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  width 100%
  height 100%
  position relative
  color $fontColor
  div#header
    width 100%
    height 50px
    background-color $backgroundColor
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.20);
  div#content
    position absolute
    top 50px
    width 100%
    left 0
    bottom 0
    display flex
    background-color $backgroundColor
    div#left
      width 20%
      min-width 300px
      max-width 406px
      height 100%
      background-color $themeColor
    div#center
      height 100%
      flex-grow 1
    div#right
      width 20%
      min-width 300px
      max-width 406px
      height 100%
      background-color $themeColor
    .column
      padding 8px
      display flex
      flex-direction column
      > div:not(:first-child)
        margin-top 8px
      > div:last-child
        flex-grow 1
</style>
